import { render, staticRenderFns } from "./ConfigurarCertificadoFormTexto.vue?vue&type=template&id=38761f46&scoped=true&"
import script from "./ConfigurarCertificadoFormTexto.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarCertificadoFormTexto.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarCertificadoFormTexto.vue?vue&type=style&index=0&id=38761f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38761f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('38761f46', component.options)
    } else {
      api.reload('38761f46', component.options)
    }
    module.hot.accept("./ConfigurarCertificadoFormTexto.vue?vue&type=template&id=38761f46&scoped=true&", function () {
      api.rerender('38761f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosBase/ConfigurarCertificadoFormTexto.vue"
export default component.exports